/*
 * @Author: dingzhx 2803192627@qq.com
 * @Date: 2022-06-25 22:49:20
 * @LastEditors: dingzhx 2803192627@qq.com
 * @LastEditTime: 2022-07-15 10:37:53
 * @FilePath: \hmzy-intl-portal\src\config\appConfig.js
 * @Description: appConfig
 */
let host = "localhost:8031";
let useSsl = false;
let relativePath = "";
let imgUploadHost = "hmzy.cosmoplat.com/userweb";

if (process.env["NODE_ENV"] === "development") {
  imgUploadHost = "hmzy.cosmoplat.com/userweb";
  host = "hmzy.cosmoplat.com";
  useSsl = true;
  relativePath = "/hicweb";
}

if (process.env["NODE_ENV"] === "staging") {
  host = "10.189.2.212:8031";
  useSsl = false;
  // imgUploadHost = "10.138.228.199:30558";
}

if (process.env["NODE_ENV"] === "production") {
  imgUploadHost = "hmzy.cosmoplat.com/userweb";
  host = "hmzy.cosmoplat.com";
  useSsl = true;
  relativePath = "/hicweb";
}

const apiProtocol = useSsl ? "https" : "http";
const websocketProtocol = useSsl ? "wss" : "ws";

export const hmzyUrl = `${apiProtocol}://${imgUploadHost}`;
export const IMUrl = `${apiProtocol}://${host}${relativePath}/hicMessage`;
export const webSocketUrl = `${websocketProtocol}://${host}${relativePath}`;
export const palFormUrl = `${apiProtocol}://${host}${relativePath}`;
